export const generalI18n = [
    {
        key: 'date',
        de: 'Datum',
        en: 'Date',
        it: 'Data',
        fr: 'Date',
        nl: 'Datum',
    },
    {
        key: 'time',
        de: 'Uhrzeit',
        en: 'Time',
        it: 'Ora',
    },
    {
        key: 'monday',
        de: 'Mo',
        en: 'Mon',
        it: 'Lun',
        fr: 'Lun',
        nl: 'Ma',
    },
    {
        key: 'tuesday',
        de: 'Di',
        en: 'Tue',
        it: 'Mar',
        fr: 'Mar',
        nl: 'Di',
    },
    {
        key: 'wednesday',
        de: 'Mi',
        en: 'Wed',
        it: 'Mer',
        fr: 'Merc',
        nl: 'Wo',
    },
    {
        key: 'thursday',
        de: 'Do',
        en: 'Thu',
        it: 'Gio',
        fr: 'Jeu',
        nl: 'Do',
    },
    {
        key: 'friday',
        de: 'Fr',
        en: 'Fri',
        it: 'Ven',
        fr: 'Ven',
        nl: 'Vr',
    },
    {
        key: 'saturday',
        de: 'Sa',
        en: 'Sat',
        it: 'Sab',
        fr: 'Sam',
        nl: 'Za',
    },
    {
        key: 'sunday',
        de: 'So',
        en: 'Sun',
        it: 'Dom',
        fr: 'Dim',
        nl: 'Zo',
    },
    {
        key: 'january-short',
        de: 'Jän',
        en: 'Jan',
        it: 'Gen',
        fr: 'Janv',
        nl: 'Jan',
    },
    {
        key: 'february-short',
        de: 'Feb',
        en: 'Feb',
        it: 'Feb',
        fr: 'Févr',
        nl: 'Feb',
    },
    {
        key: 'march-short',
        de: 'Mär',
        en: 'Mar',
        it: 'Mar',
        fr: 'Mars',
        nl: 'Mrt',
    },
    {
        key: 'april-short',
        de: 'Apr',
        en: 'Apr',
        it: 'Apr',
        fr: 'Avr',
        nl: 'Apr',
    },
    {
        key: 'may-short',
        de: 'Mai',
        en: 'May',
        it: 'Mag',
        fr: 'Mai',
        nl: 'Mei',
    },
    {
        key: 'june-short',
        de: 'Jun',
        en: 'Jun',
        it: 'Giu',
        fr: 'Juin',
        nl: 'Jun',
    },
    {
        key: 'july-short',
        de: 'Jul',
        en: 'Jul',
        it: 'Lug',
        fr: 'Juill',
        nl: 'Jul',
    },
    {
        key: 'august-short',
        de: 'Aug',
        en: 'Aug',
        it: 'Ago',
        fr: 'Août',
        nl: 'Aug',
    },
    {
        key: 'september-short',
        de: 'Sep',
        en: 'Sep',
        it: 'Sett',
        fr: 'Sept',
        nl: 'Sep',
    },
    {
        key: 'october-short',
        de: 'Okt',
        en: 'Oct',
        it: 'Ott',
        fr: 'Oct',
        nl: 'Okt',
    },
    {
        key: 'november-short',
        de: 'Nov',
        en: 'Nov',
        it: 'Nov',
        fr: 'Nov',
        nl: 'Nov',
    },
    {
        key: 'december-short',
        de: 'Dez',
        en: 'Dec',
        it: 'Dic',
        fr: 'Déc',
        nl: 'Dec',
    },
    {
        key: 'january',
        de: 'Jänner',
        en: 'January',
        it: 'Gennaio',
        fr: 'Janvier',
        nl: 'Januari',
    },
    {
        key: 'february',
        de: 'Februar',
        en: 'February',
        it: 'Febbraio',
        fr: 'Février',
        nl: 'Februari',
    },
    {
        key: 'march',
        de: 'März',
        en: 'March',
        it: 'Marzo',
        fr: 'Mars',
        nl: 'Maart',
    },
    {
        key: 'april',
        de: 'April',
        en: 'April ',
        it: 'Aprile',
        fr: 'Avril',
        nl: 'April',
    },
    {
        key: 'may',
        de: 'Mai',
        en: 'May',
        it: 'Maggio',
        fr: 'Mai',
        nl: 'Mei',
    },
    {
        key: 'june',
        de: 'Juni',
        en: 'June',
        it: 'Giugno',
        fr: 'Juin',
        nl: 'Juni',
    },
    {
        key: 'july',
        de: 'Juli',
        en: 'July',
        it: 'Luglio',
        fr: 'Juillet',
        nl: 'Juli',
    },
    {
        key: 'august',
        de: 'August',
        en: 'August',
        it: 'Agosto',
        fr: 'Août',
        nl: 'Augustus',
    },
    {
        key: 'september',
        de: 'September ',
        en: 'September ',
        it: 'Settembre',
        fr: 'Septembre',
        nl: 'September',
    },
    {
        key: 'october',
        de: 'Oktober ',
        en: 'October ',
        it: 'Ottobre',
        fr: 'Octobre',
        nl: 'Oktober',
    },
    {
        key: 'november',
        de: 'November',
        en: 'November',
        it: 'Novembre',
        fr: 'Novembre',
        nl: 'November',
    },
    {
        key: 'december',
        de: 'Dezember',
        en: 'December ',
        it: 'Dicembre',
        fr: 'Décembre',
        nl: 'December',
    },
    {
        key: 'today',
        de: 'heute',
        en: 'today',
        it: 'oggi',
    },
];
//# sourceMappingURL=general-i18n.js.map
